import { Controller } from "@hotwired/stimulus";
import "select2";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.selectTarget = $(this.element).find('select');
    this.placeholder = this.selectTarget.data('placeholder') || 'Selecione uma opção...';
    
    const isMultiple = this.selectTarget.prop('multiple');
    
    // Remove campo hidden para selects múltiplos
    if (isMultiple) {
      this.removeHiddenField();
    }
    
    const commonOptions = {
      placeholder: this.placeholder,
      minimumInputLength: 0,
      width: '100%',
      language: 'pt-BR',
      allowClear: true,
      dropdownParent: $(document.body),
      // Força campo de busca no dropdown para todos os selects
      minimumResultsForSearch: 0,
      // Para select múltiplo, força configurações específicas
      ...(isMultiple && {
        closeOnSelect: false,
        escapeMarkup: function (markup) { return markup; },
        templateResult: function(data) { return data.text; },
        templateSelection: function(data) { return data.text; }
      })
    };

    if (this.hasUrlValue) {
      this.initWithAjax(commonOptions);
    } else {
      this.init(commonOptions);
    }

    // Configura placeholder para todos os selects
    this.setupPlaceholders();
  }

  init(commonOptions) {
    this.selectTarget.select2(commonOptions);
    
    // Para select múltiplo, força o campo de busca no dropdown
    if (this.selectTarget.prop('multiple')) {
      this.selectTarget.on('select2:open', () => {
        // Sempre força a criação do campo de busca
        setTimeout(() => {
          const dropdown = $('.select2-dropdown');
          if (dropdown.length) {
            // Remove campo existente se houver
            dropdown.find('.select2-search--dropdown').remove();
            
            // Cria novo campo de busca
            const searchHtml = '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="0" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" autocomplete="off" aria-label="Search" placeholder="Digite para buscar..."></span>';
            dropdown.prepend(searchHtml);
            
            // Conecta a funcionalidade de busca
            const searchField = dropdown.find('.select2-search__field');
            
            // Foca automaticamente no campo de busca
            setTimeout(() => {
              searchField.focus();
            }, 50);
            
            searchField.on('input', (e) => {
              const term = e.target.value.toLowerCase();
              dropdown.find('.select2-results__option').each(function() {
                const text = $(this).text().toLowerCase();
                if (text.includes(term)) {
                  $(this).show();
                } else {
                  $(this).hide();
                }
              });
            });
          }
        }, 10);
      });
    }
  }

  initWithAjax(commonOptions) {
    this.selectTarget.select2({
      ...commonOptions,
      ajax: {
        url: this.urlValue,
        dataType: 'json',
        delay: 250,
        data: (params) => {
          return {
            pgq: params.term,
            json_select: true,
            page: params.page || 1
          };
        },
        processResults: (data, params) => {
          params.page = params.page || 1;
          return {
            results: data.results,
            pagination: {
              more: data.pagination.more
            }
          };
        },
        cache: true
      }
    });
    
    // Para select múltiplo, força o campo de busca no dropdown
    if (this.selectTarget.prop('multiple')) {
      this.selectTarget.on('select2:open', () => {
        // Sempre força a criação do campo de busca
        setTimeout(() => {
          const dropdown = $('.select2-dropdown');
          if (dropdown.length) {
            // Remove campo existente se houver
            dropdown.find('.select2-search--dropdown').remove();
            
            // Cria novo campo de busca
            const searchHtml = '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="0" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" autocomplete="off" aria-label="Search" placeholder="Digite para buscar..."></span>';
            dropdown.prepend(searchHtml);
            
            // Conecta a funcionalidade de busca
            const searchField = dropdown.find('.select2-search__field');
            
            // Foca automaticamente no campo de busca
            setTimeout(() => {
              searchField.focus();
            }, 50);
            
            searchField.on('input', (e) => {
              const term = e.target.value.toLowerCase();
              dropdown.find('.select2-results__option').each(function() {
                const text = $(this).text().toLowerCase();
                if (text.includes(term)) {
                  $(this).show();
                } else {
                  $(this).hide();
                }
              });
            });
          }
        }, 10);
      });
    }
  }

  setupPlaceholders() {
    setTimeout(() => {
      if (this.selectTarget.prop('multiple')) {
        // Para selects múltiplos, gerencia a classe visual e placeholder
        const container = this.selectTarget.next('.select2-container');
        const selection = container.find('.select2-selection--multiple');
        const rendered = selection.find('.select2-selection__rendered');
        
        // Define o placeholder no elemento
        rendered.attr('data-placeholder', this.placeholder);
        
        const updateState = () => {
          setTimeout(() => {
            const hasSelections = this.selectTarget.val() && this.selectTarget.val().length > 0;
            
            if (!hasSelections) {
              selection.addClass('select2-no-selections');
            } else {
              selection.removeClass('select2-no-selections');
            }
          }, 10);
        };
        
        // Atualiza inicialmente e quando a seleção muda
        updateState();
        this.selectTarget.on('change', updateState);
        this.selectTarget.on('select2:unselect', updateState);
        this.selectTarget.on('select2:clear', updateState);
      } else {
        // Para select simples, configura placeholder do campo de busca
        this.selectTarget.on('select2:open', () => {
          setTimeout(() => {
            const searchField = $('.select2-search--dropdown .select2-search__field');
            if (searchField.length) {
              searchField.attr('placeholder', 'Digite para buscar...');
            }
          }, 50);
        });
      }
    }, 100);
  }

  removeHiddenField() {
    // Remove o campo hidden que o Rails adiciona para arrays
    const hiddenField = this.selectTarget.siblings('input[type="hidden"]').first();
    if (hiddenField.length && hiddenField.attr('name') === this.selectTarget.attr('name')) {
      hiddenField.remove();
    }
  }

  disconnect() {
    this.selectTarget.select2('destroy');
  }
}
